import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EASE = [0.22, 1, 0.36, 1];

const Expertise = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/services`).then((r) => setItems(r.data.expertise)).catch(() => {});
  }, []);

  return (
    <section id="expertise" className="relative py-28 lg:py-36 bg-[#F8FAFC] border-y border-slate-200" data-testid="expertise-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: EASE }}
          className="font-mono2 text-xs sm:text-sm uppercase tracking-[0.25em] text-amber-600 mb-5"
        >
          Core Capabilities
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
          className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight mb-16 max-w-2xl"
        >
          Deep Functional & Technical Domain Mastery.
        </motion.h2>

        <div className="border-t border-slate-200">
          {items.map((e, i) => (
            <motion.div
              key={e.domain}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, ease: EASE, delay: i * 0.05 }}
              className="group grid lg:grid-cols-12 gap-4 lg:gap-8 items-center py-8 border-b border-slate-200 hover:bg-slate-50 transition-colors duration-300 px-2 lg:px-4"
              data-testid={`expertise-row-${i}`}
            >
              <span className="lg:col-span-1 font-mono2 text-sm text-slate-500 group-hover:text-amber-600 transition-colors duration-300">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="lg:col-span-4 font-display text-xl sm:text-2xl font-bold tracking-tight">{e.domain}</h3>
              <span className="lg:col-span-2">
                <span className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-amber-600 border border-amber-400/30 bg-amber-400/10 px-3 py-1 rounded-full">
                  {e.level}
                </span>
              </span>
              <p className="lg:col-span-5 text-sm text-slate-600 leading-relaxed">{e.description}</p>
              {e.slug && (
                <Link
                  to={`/expertise/${e.slug}`}
                  className="lg:col-span-12 -mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-slate-700 hover:text-amber-700 transition-colors"
                  data-testid={`expertise-link-${e.slug}`}
                >
                  Read the deep-dive <ArrowUpRight size={12} />
                </Link>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
